import { render, staticRenderFns } from "./projectKp.vue?vue&type=template&id=46fe0092&scoped=true&"
import script from "./projectKp.vue?vue&type=script&lang=ts&"
export * from "./projectKp.vue?vue&type=script&lang=ts&"
import style0 from "./projectKp.vue?vue&type=style&index=0&id=46fe0092&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe0092",
  null
  
)

export default component.exports